import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight, TrendingUp } from 'lucide-react';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "GST Return Filing Deadlines for January 2026",
      excerpt: "Important dates and compliance requirements for GSTR-1, GSTR-3B filing. Stay compliant and avoid penalties.",
      date: "January 15, 2026",
      category: "GST Updates",
      readTime: "3 min read",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 2,
      title: "Top 10 Tax Saving Options for FY 2025-26",
      excerpt: "Maximize your tax savings with these proven strategies under Section 80C, 80D, and other deductions.",
      date: "January 10, 2026",
      category: "Tax Planning",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      title: "New Income Tax Slab Rates 2026 - What Changed?",
      excerpt: "Complete breakdown of new and old tax regime comparison. Choose wisely to save maximum tax.",
      date: "January 5, 2026",
      category: "Income Tax",
      readTime: "4 min read",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80"
    }
  ];

  const importantDates = [
    { date: "Jan 31", event: "TDS/TCS Payment (Dec)" },
    { date: "Feb 7", event: "GSTR-7 Filing (TDS Return)" },
    { date: "Feb 11", event: "GSTR-1 Filing (Monthly)" },
    { date: "Feb 13", event: "GSTR-6 Filing (ISD)" },
    { date: "Feb 20", event: "GSTR-3B Filing (Monthly)" }
  ];

  return (
    <div className="blog-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="container">
          <h1 className="page-hero-title">Tax Updates & Insights</h1>
          <p className="page-hero-subtitle">
            Stay updated with latest GST, Income Tax & Compliance news
          </p>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-content-section">
        <div className="container">
          <div className="blog-layout">
            {/* Main Content */}
            <div className="blog-main">
              <h2 className="blog-section-title">Latest Updates</h2>
              
              <div className="blog-posts-grid">
                {blogPosts.map((post) => (
                  <article key={post.id} className="blog-post-card">
                    <div className="blog-post-image">
                      <img src={post.image} alt={post.title} />
                      <span className="blog-category">{post.category}</span>
                    </div>
                    <div className="blog-post-content">
                      <div className="blog-post-meta">
                        <span className="blog-date">
                          <Calendar size={14} /> {post.date}
                        </span>
                        <span className="blog-read-time">
                          <Clock size={14} /> {post.readTime}
                        </span>
                      </div>
                      <h3 className="blog-post-title">{post.title}</h3>
                      <p className="blog-post-excerpt">{post.excerpt}</p>
                      <Link to={`/blog/${post.id}`} className="blog-read-more">
                        Read More <ArrowRight size={16} />
                      </Link>
                    </div>
                  </article>
                ))}
              </div>

              <div className="blog-coming-soon">
                <TrendingUp size={48} />
                <h3>More Updates Coming Soon!</h3>
                <p>We regularly publish articles on tax updates, compliance tips, and financial planning advice.</p>
                <Link to="/contact" className="btn btn-outline">
                  Subscribe for Updates
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="blog-sidebar">
              <div className="sidebar-widget">
                <h3 className="sidebar-widget-title">Important Dates</h3>
                <div className="important-dates-list">
                  {importantDates.map((item, index) => (
                    <div key={index} className="important-date-item">
                      <div className="date-badge">{item.date}</div>
                      <div className="date-event">{item.event}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="sidebar-widget">
                <h3 className="sidebar-widget-title">Categories</h3>
                <ul className="blog-categories">
                  <li><Link to="/blog?category=gst">GST Updates</Link></li>
                  <li><Link to="/blog?category=income-tax">Income Tax</Link></li>
                  <li><Link to="/blog?category=compliance">Compliance</Link></li>
                  <li><Link to="/blog?category=tax-planning">Tax Planning</Link></li>
                  <li><Link to="/blog?category=audit">Audit & Assurance</Link></li>
                </ul>
              </div>

              <div className="sidebar-widget sidebar-cta">
                <h3 className="sidebar-widget-title">Need Expert Advice?</h3>
                <p>Get personalized tax and compliance guidance from our experts.</p>
                <Link to="/contact" className="btn btn-primary btn-block">
                  Book Consultation
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
